import { render } from "./formItem.vue?vue&type=template&id=bd72ef16&scoped=true"
import script from "./formItem.vue?vue&type=script&lang=js"
export * from "./formItem.vue?vue&type=script&lang=js"

import "./formItem.vue?vue&type=style&index=0&id=bd72ef16&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd72ef16"]])

export default __exports__